import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import {
  createFormFieldsByIdGetter,
} from 'client/helpers/formikHelpers';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';
import SrText from 'client/components/SrText';

const SrOccupancy = ({
  formikBag,
  formFields,
}) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const getFormFieldsById = createFormFieldsByIdGetter(formFields);
  const clientWantsPropertyManagementField = getFormFieldsById('clientWantsPropertyManagement');

  return (
    <SrCard>
      {formFields.filter((formField) => formField.id !== 'clientWantsPropertyManagement')
        .map((formField, index) => (
          <div key={formField.id}>
            <SrBox>
              <SrFormikField
                formField={formField}
                formikBag={formikBag}
                theme={SR_FIELD_THEME_ADOBE}
                margin={index === 0 ? '0px' : null}
              />
            </SrBox>
            {formField.type !== 'hidden' && formField.actionLink && (
              <SrBox
                marginTop='15px'
                marginBottom='24px'
                onClick={formField.actionLink.onClick}
              >
                <SrText
                  font='greycliff'
                  color='blue300'
                  weight='800'
                  align={isSmallScreen ? 'center' : null}
                  size='16'
                  lineHeight='25px'
                  cursor='pointer'
                  display='block'
                >
                  {formField.actionLink.text}
                </SrText>
              </SrBox>
            )}
            {formField.type !== 'hidden' && formField.additionalComponent}
          </div>
        ))}
      {clientWantsPropertyManagementField && (
        <SrGridRow columns={1} width='410px'>
          <SrFormikField
            formField={clientWantsPropertyManagementField}
            formikBag={formikBag}
            theme={SR_FIELD_THEME_ADOBE}
          />
        </SrGridRow>
      )}
    </SrCard>
  );
};

SrOccupancy.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrOccupancy.displayName = 'SrOccupancy';

export default SrOccupancy;
